import { updateRow } from "./table";
import { isValidEmail } from "./utils";

export const isEmailBcc = (to = [], cc = [], userEmail) => {
  // Handle null/undefined inputs
  const toEmails = to || [];
  const ccEmails = cc || [];

  // Helper function to extract email address from various formats
  const extractEmailAddress = (emailString) => {
    if (!emailString) return '';

    // Extract email from Name <email> format
    const nameEmailRegex = /^.+?\s*<([^>]*)>$/;
    const nameEmailMatch = emailString.match(nameEmailRegex);
    if (nameEmailMatch) {
      const [, email] = nameEmailMatch;
      return email.trim();
    }

    // Extract email from <email> format
    const bracketEmailRegex = /^<([^>]+)>$/;
    const bracketEmailMatch = emailString.match(bracketEmailRegex);
    if (bracketEmailMatch) {
      const [, email] = bracketEmailMatch;
      return email.trim();
    }

    // Plain email format
    return emailString.trim();
  };

  // Extract the user's email address
  const userEmailAddress = extractEmailAddress(userEmail);

  // Check if the user's email address is in the to or cc lists
  for (const email of toEmails) {
    if (extractEmailAddress(email) === userEmailAddress) {
      return false;
    }
  }

  for (const email of ccEmails) {
    if (extractEmailAddress(email) === userEmailAddress) {
      return false;
    }
  }

  return true;
}

export const htmlToPlainText = (html) => {
  return html.replace(/<[^>]*>?/gm, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"');
};

export const parseEmailFormat = (emailString) => {
  if (!emailString) return '';

  // Case 3: Name <email> - return the name (only if name is not empty)
  const nameEmailRegex = /^(.+?)\s*<([^>]*)>$/;
  const nameEmailMatch = emailString.match(nameEmailRegex);
  if (nameEmailMatch) {
    const [, name] = nameEmailMatch;
    return name.trim();
  }

  // Case 2: <email> - return the email (no name available)
  const bracketEmailRegex = /^<([^>]+)>$/;
  const bracketEmailMatch = emailString.match(bracketEmailRegex);
  if (bracketEmailMatch) {
    const [, email] = bracketEmailMatch;
    return email.trim();
  }

  // Case 1: plain email - return as is
  return emailString.trim();
};

export const extractEmailAddress = (emailString) => {
  if (!emailString) return '';

  // Extract email from Name <email> format
  const nameEmailRegex = /^.+?\s*<([^>]*)>$/;
  const nameEmailMatch = emailString.match(nameEmailRegex);
  if (nameEmailMatch) {
    const [, email] = nameEmailMatch;
    return email.trim();
  }

  // Extract email from <email> format
  const bracketEmailRegex = /^<([^>]+)>$/;
  const bracketEmailMatch = emailString.match(bracketEmailRegex);
  if (bracketEmailMatch) {
    const [, email] = bracketEmailMatch;
    return email.trim();
  }

  // Plain email format
  return emailString.trim();
};

export const harmonizeEmail = (tableId, email, userEmail, activeBusiness, router) => {

  if ((extractEmailAddress(email.data.from) === userEmail) && userEmail) {
    const payload = {
      namespace: 'sent',
    }
    if (!email.namespace) {
      // console.log("Updating email namespace to sent");

      updateRow(tableId, email.id, payload, null, activeBusiness, null, router);
    }
  }
  else if (extractEmailAddress(email.data.from) !== userEmail) {
    const payload = {
      namespace: 'inbox',
    }
    if (!email.namespace) {
      // console.log("Updating email namespace to inbox");
      updateRow(tableId, email.id, payload, null, activeBusiness, null, router);
    }
  }

}

// Takes the lists to check: the previous version closed over `recipients`,
// `ccRecipients` and `bccRecipients`, which exist only inside the composer, so
// any caller of this helper got a ReferenceError.
export const hasInvalidEmails = (recipients = [], ccRecipients = [], bccRecipients = []) => {
  const allEmails = [...recipients, ...ccRecipients, ...bccRecipients];
  return allEmails.some(email => !isValidEmail(extractEmailAddress(email)));
};